import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95a9a488"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login-modal"
}
const _hoisted_2 = {
  key: 1,
  class: "signModal"
}
const _hoisted_3 = { class: "signupTitle flex-cen-ter" }

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Login from '@/components/Login/index.vue'
import SignupForm from '@/components/Signup/form.vue'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
store.commit('route/uuid', '')

const onsuccess = (key: string) => {
  store.commit('status/onLogin', false)
  store.commit('route/uuid', key)
  router.replace({ name: 'signup' })
}

const afterLogin = (res: any) => {
  location.reload()
  // store.commit('status/loginPanel', 'login')
  // if (res?.memberShipResp?.templateLevel < 1) {
  //   store
  //     .dispatch('guide/getGuide', {
  //       customerId: store.getters.user?.customerId
  //     })
  //     .then(() => {
  //       if (!store.state?.guide?.guideState?.['guide-pure-all']) {
  //         store.commit('status/memberDialog', true)
  //       }
  //     })
  // }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": !!_unref(store).state.status.onLogin,
    "destroy-on-close": true,
    width: "565px",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    onClosed: _cache[0] || (_cache[0] = ($event: any) => {
      _unref(store).commit('status/loginPanel', 'login');
    _unref(store).commit('status/onLogin', null);
    }),
    "custom-class": "loginDialog"
  }, {
    default: _withCtx(() => [
      (_unref(store).state.status.loginPanel === 'login')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(Login, {
              onOnsuccess: afterLogin,
              "is-ram": true
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('注册')), 1),
            _createVNode(SignupForm, {
              ref: (_value, _refs) => {
                _refs['signupFormRef'] = _value
              },
              onSuccess: onsuccess,
              "is-ram": true
            }, null, 512)
          ]))
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})